import { ApiCountryContextResultSchema } from "@bridge-applications/pb-types";
import { z } from "zod";

export const AnalyticsContextSliceSchema = z.object({
    userId: z.uuid().nullable(),
    status: z.enum(["idle", "loading", "ready", "unavailable"]),
    countryContext: ApiCountryContextResultSchema.nullable(),
});
export type AnalyticsContextSlice = z.infer<typeof AnalyticsContextSliceSchema>;
